import { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider.jsx'
import { supabase } from '../data/supabase.js'
import Toast from '../components/Toast.jsx'

export default function LoginPage() {
  const { login: doLogin, session } = useAuth()
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [busy, setBusy] = useState(false)
  const [toast, setToast] = useState(null)

  // Detectar confirmação de email via token na URL (#access_token=...&type=signup)
  useEffect(() => {
    const hash = window.location.hash
    if (hash && hash.includes('access_token') && hash.includes('type=signup')) {
      supabase.auth.getSession().then(({ data }) => {
        if (data?.session) {
          nav('/app')
        }
      })
    }
  }, [nav])

  // Redirecionar se usuário já estiver logado
  useEffect(() => {
    if (session) {
      nav(session.isSuperAdmin && !session._impersonating ? '/super-admin' : '/app')
    }
  }, [session, nav])

  async function onSubmit(e) {
    e.preventDefault()
    setBusy(true)
    try {
      console.log('[LoginPage] Iniciando login com email...')
      await doLogin({ login: email.trim(), senha: senha })
      console.log('[LoginPage] Login bem-sucedido, redirecionando...')
      
    } catch (err) {
      console.error('[LoginPage] Erro no login:', err)
      
      // Solução final - garantir mensagem sempre
      const errorMessage = err?.message || err?.toString() || 'Falha ao entrar.'
      setToast({ message: errorMessage, type: 'error' })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="relative h-screen w-screen overflow-hidden text-white">
      {/* Fundo fixo */}
      <div className="fixed inset-0 z-0 cm-bg" />
      <div className="fixed inset-0 z-0 cm-bg-overlay" />
      
      <Toast message={toast?.message} type={toast?.type || 'error'} onClose={() => setToast(null)} />
      <div className="relative z-10 mx-auto flex h-full w-full max-w-lg flex-col px-4 py-10 overflow-y-auto">
        <div className="mb-4">
          <a 
            href="https://caixamestre.com.br"
            className="text-xs text-white/50 hover:text-white/80 transition-colors"
          >← Voltar ao site</a>
        </div>
        <div className="flex flex-col items-center">
          <div className="h-20 w-20 overflow-hidden rounded-3xl bg-white/10">
            <img src="/logo.png" alt="CAIXA MESTRE" className="h-full w-full object-contain" />
          </div>
          <div className="mt-4 text-xl font-semibold">CAIXA MESTRE</div>
          <div className="mt-1 text-sm text-white/70">Gestão de Estoque</div>
        </div>

        <form className="mt-8 rounded-2xl cm-card p-4" onSubmit={onSubmit}>
          <label className="block text-xs text-white/70">Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoCapitalize="none"
            autoCorrect="off"
            type="email"
            autoComplete="email"
            className="mt-1 w-full rounded-xl bg-white/10 px-3 py-3 text-sm outline-none placeholder:text-white/40"
            placeholder="Digite seu email"
          />

          <label className="mt-4 block text-xs text-white/70">Senha</label>
          <input
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            type="password"
            autoComplete="current-password"
            className="mt-1 w-full rounded-xl bg-white/10 px-3 py-3 text-sm outline-none placeholder:text-white/40"
            placeholder="Digite sua senha"
          />

          <button
            disabled={busy}
            className="mt-5 w-full rounded-xl bg-accent-600 px-3 py-3 text-sm font-semibold text-white disabled:opacity-60"
          >
            {busy ? 'Entrando…' : 'Entrar'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <div className="text-xs text-white/40 mb-3">Ainda não tem conta?</div>
          <Link
            to="/cadastro"
            className="block w-full rounded-xl bg-emerald-600 px-3 py-3 text-sm font-semibold text-white hover:bg-emerald-500 transition-colors text-center"
          >
            Criar conta grátis
          </Link>
        </div>
      </div>
    </div>
  )
}
